import axios from 'axios';
const state = {
    kudosTypes: [],
	avatarColors: {
		a: '#43d59d',
		ą: '#7020f5',
		b: '#8663e1',
		c: '#a114a4',
		ć: '#db7f78',
		d: '#d63202',
		e: '#b11676',
		ę: '#b6f80a',
		f: '#8465b4',
		g: '#0caec4',
		h: '#b20440',
		i: '#14b758',
		j: '#166194',
		k: '#708b84',
		l: '#d333d3',
		ł: '#e23ac7',
		m: '#8aa045',
		n: '#079407',
		ń: '#6a91ac',
		o: '#2a5237',
		ó: '#9027b3',
		p: '#6065fa',
		q: '#1d2408',
		r: '#777f4b',
		s: '#3063b1',
		ś: '#7c41ee',
		t: '#86ba35',
		u: '#6573af',
		v: '#4225ec',
		w: 'hsl(210, 76%, 35%)',
		x: 'rgb(97, 111, 158)',
		y: '#d748c0',
		z: '#89016a',
		ź: '#5801c8',
		ż: '#9c9f41',
	},
	problemStatuses: [
		{
			name: 'new',
			title: '$vuetify.views.wall.problem.status.new',
			class: 'status-new'
		},
		{
			name: 'in_progress',
			title: '$vuetify.views.wall.problem.status.inProgress',
			class: 'status-in-progress'
		},
		{
			name: 'analyzed',
			title: '$vuetify.views.wall.problem.status.analyzed',
			class: 'status-analyzed'
		},
		{
			name: 'resolved',
			title: '$vuetify.views.wall.problem.status.resolved',
			class: 'status-resolved'
		}
	],
};

const getters = {
	kudosTypes: state => {
		return state.kudosTypes;
	},
	avatarColors: state => {
		return state.avatarColors
	},
	problemStatuses: state => {
		return state.problemStatuses
	}
}

const mutations = {
	setKudosTypes(state, payload) {
        state.kudosTypes = payload;
    },
}

const actions = {
	async getKudosTypes({commit}, payload) {
		let res = null;
		await axios.get('kudos-types', payload).then(response => {
			commit('setKudosTypes', response.data.data);
			res = {
				success: true,
				error: null,
				data: response.data.data
			}
		})
		.catch(error => {
			res = {
				success: false,
				error: error,
				data: null
			}
		})
		return res;
	}
}

export default {
    namespaced: true,
	state,
	getters,
	mutations,
    actions,
};